interface FAQ { q: string; a: string }

interface Props {
  heading?: string;
  intro?: string;
  faqs: FAQ[];
}

/**
 * "Related buyer questions" block — the destination pattern used during
 * Phase 5.5 content salvage. Preserves the exact long-tail buyer phrasing
 * from soon-to-be-redirected source pages so search + AI engines keep
 * the intent match when the source URLs 301.
 */
const SalvagedBuyerFAQs = ({
  heading = 'Related questions this page answers',
  intro,
  faqs,
}: Props) => (
  <section className="not-prose my-12 rounded-2xl border border-border bg-card/60 p-6 md:p-8">
    <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-3">
      Related buyer questions
    </p>
    <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">{heading}</h2>
    {intro && (
      <p className="text-muted-foreground leading-relaxed mb-6">{intro}</p>
    )}
    <dl className="space-y-6">
      {faqs.map((f) => (
        <div key={f.q}>
          <dt className="text-base md:text-lg font-semibold text-foreground mb-1">
            {f.q}
          </dt>
          <dd className="text-sm md:text-base text-muted-foreground leading-relaxed">
            {f.a}
          </dd>
        </div>
      ))}
    </dl>
  </section>
);

export default SalvagedBuyerFAQs;
